import {useContext, useEffect} from "react";
import { useLocation } from "react-router-dom";
import {GlobalContext} from "../../stores/GlobalStore";
import {useTranslation} from "react-i18next";

const UrlErrorChecker = (props) => {
    const { state, dispatch } = useContext(GlobalContext);
    const { t } = useTranslation();
    const location = useLocation();

    const errorReasonToMessage = (t, reason, productData) => {
        switch (reason) {
            case "PRODUCT_ONEOFF_HYBRID" :
                return t("error.ProductIsHybrid", {internalId: productData.internalId, externalId: productData.externalId});
            case "USER_NOT_ELIGIBLE_ERROR" :
                return t("error.IneligibleUser");
            default:
                return t("error.TechnicalError");
        }
    }


    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const isError = searchParams.get("error") === "true";
        const reason = searchParams.get("reason");

        if (isError && !state.error.isError && state.product.isLoaded) {
            const message = errorReasonToMessage(t, reason, state.product.data);
            dispatch({
                type: "SET_ERROR",
                payload: { message },
            });
        }
    }, [location.search, state.error.isError, state.product.isLoaded, state.product.data, t, dispatch]);

    return <>{props.children}</>;
};

export default UrlErrorChecker;
